import { render, staticRenderFns } from "./UserProfileForm.vue?vue&type=template&id=707604d8&scoped=true&"
import script from "./UserProfileForm.vue?vue&type=script&lang=js&"
export * from "./UserProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileForm.vue?vue&type=style&index=0&id=707604d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707604d8",
  null
  
)

export default component.exports